import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HireItem } from '../../models/hire-item';
import { ApiClient } from '../api.client';
import { HireItemAttachment } from '../../models/HireItemAttachment';

@Injectable()
export class HireItemService {
  API_URL = 'http://localhost:8080/';

  constructor(private http: ApiClient) {}

  create(docketId, attributes): Observable<HireItem> {
    return this.http.post<HireItem>(
      'docket/' + docketId + '/hireitems',
      attributes
    );
  }

  update(hireItemId, docketId, attributes) {
    return this.http.put(
      'docket/' + docketId + '/hireitems/' + hireItemId,
      attributes
    );
  }

  bulkUpdate(docketId, items) {
    return this.http.put('docket/' + docketId + '/hireitems', items);
  }

  delete(docketId, itemId) {
    return this.http.delete('docket/' + docketId + '/hireitems/' + itemId);
  }

  offHireItems(docketId, offHire) {
    return this.http.put('docket/' + docketId + '/hireitems/offHire', offHire);
  }

  addItemAttachment(
    docketId: number,
    itemId: number,
    {
      file,
      description,
      stage
    }: { file: File; description: string; stage: string }
  ) {
    const formData = new FormData();
    formData.append('file', file);
    formData.set('description', description);
    formData.set('stage', stage);
    return this.http.post<HireItemService>(
      `docket/${docketId}/hireitems/${itemId}/attachments`,
      formData
    );
  }

  getAttachmentUploadUrl(
    docketId: number,
    itemId: number,
    fileName: string,
    uuid: string,
    index: number
  ) {
    return this.http.get(
      `docket/${docketId}/hireitems/${itemId}/attachments/get-upload-url?filename=${encodeURIComponent(
        fileName
      )}&uuid=${uuid}&index=${index}`
    );
  }

  associateAttachment(
    docketId: number,
    itemId: number,
    payload: {
      uuid: string;
      description: string;
      stage: string;
      filename: string;
      index: number;
    }
  ) {
    return this.http.post(
      `docket/${docketId}/hireitems/${itemId}/attachments/associate`,
      payload
    );
  }

  getItemAttachments(docketId: number, itemId: number) {
    return this.http.get<HireItemAttachment[]>(
      `docket/${docketId}/hireitems/${itemId}/attachments`
    );
  }

  deleteAttachment(docketId: number, itemId: number, attachmentId: number) {
    return this.http.delete(
      `docket/${docketId}/hireitems/${itemId}/attachments/${attachmentId}`
    );
  }

  getHireItems(docketId: number) {
    return this.http.get<HireItem[]>(`docket/${docketId}/hireitems`);
  }

  downloadAttachment(docketId: number, hireItemId: number, id: number) {
    return this.http.get(
      `docket/${docketId}/hireitems/${hireItemId}/attachments/${id}`
    );
  }

  createVirtualProductHireItems(
    docketId: number,
    payload: {
      product_id: number;
      selected_items: number[];
      charge: number;
      on_hire: string;
      off_hire: string | null;
      estimated_off_hire: string | null;
      location_out: number;
    }
  ) {
    return this.http.post<HireItem>(
      `docket/${docketId}/hireitems/virtual-product`,
      payload
    );
  }
}
